import { PureComponent } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { getEventDesktop } from "../../../../../../api/eventsApi";
import { IconBetDrawerEmpty } from "../../../../../../components/Icon/Icon";
import LoadingSpinner from "../../../../../../components/LoadingSpinner/LoadingSpinner";
import type { PositionMatrixType } from "../../../../../../types/positionMatrixType";
import PositionMatrixItem from "./components/PositionMatrixItem/PositionMatrixItem";
import "./PositionMatricesContent.scss";
type Props = {
  positionMatrixList: PositionMatrixType[];
  isPositionMatrixListLoading: boolean;
  total: number;
};

class PositionMatricesContent extends PureComponent<Props> {
  getEventData = (eventId: number) => {
    getEventDesktop(eventId).then(resp => {
      return resp;
    });
  };
  render = () => {
    const { positionMatrixList, isPositionMatrixListLoading, total } =
      this.props;

    if (positionMatrixList == null) {
      return null;
    }

    let content = null;

    if (!isPositionMatrixListLoading && positionMatrixList.length === 0) {
      content = (
        <div className="position-matrices-content__empty-list">
          <IconBetDrawerEmpty />
          <FormattedMessage
            tagName="span"
            id="bets-view-bets-report-open-bets"
          />
        </div>
      );
    } else {
      content = isPositionMatrixListLoading ? (
        <LoadingSpinner />
      ) : (
        positionMatrixList.map((positionMatrix, index) => {
          return (
            <PositionMatrixItem key={index} positionMatrix={positionMatrix} />
          );
        })
      );
    }

    return (
      <div className="position-matrices-content">
        <div className="position-matrices-content__total">
          <span id="openPositionsTotal">
            {positionMatrixList.length >= 15 ? 15 : positionMatrixList.length}
          </span>
          <span>
            <FormattedMessage tagName="span" id="bets-of" />
          </span>
          {total}
          <FormattedMessage
            tagName="span"
            id="bets-slip-open-positions-shown"
          />
        </div>
        {content}
      </div>
    );
  };
}

const mapStateToProps = state => ({
  total: state.positionMatrixListModel.total,
});

export default connect(mapStateToProps)(PositionMatricesContent) as any;
